'use strict';

var React = require('react');
var Space = require('../../Space/src/Space.js');
require('../../Typography/src/Heading.js');
require('../../Typography/src/Link.js');
require('../../Typography/src/ListItem.js');
require('../../Typography/src/OrderedList.js');
var Text = require('../../Typography/src/Text.js');
require('../../Typography/src/UnorderedList.js');
var NotFound_module = require('../styles/NotFound.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const NotFound = () => (React__namespace.createElement(Space.Space, { direction: "vertical", size: 4, justify: "center", align: "center" },
    React__namespace.createElement("svg", { width: "124", height: "96", viewBox: "0 0 124 96", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__namespace.createElement("path", { d: "M104.377 77.8535L16.3524 77.8535", stroke: "#002A3A", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__namespace.createElement("path", { d: "M83.6347 24.1265C86.9484 24.1265 89.6347 26.8128 89.6347 30.1265V72C89.6347 75.3137 86.9484 78 83.6347 78H31.8098C30.0266 77.9998 28.3164 77.2934 27.0555 76.0361C25.7946 74.7789 25.0861 73.0737 25.0859 71.2957V26C25.0859 22.6863 27.7722 20 31.0859 20H45.5959C47.3037 20 48.9241 20.7553 50.0224 22.0632C51.1206 23.3712 52.741 24.1265 54.4489 24.1265H83.6347Z", fill: "#002A3A" }),
        React__namespace.createElement("path", { d: "M97.0866 32.7969C100.124 32.7969 102.587 35.2593 102.587 38.2969V71.2952C102.586 72.9401 101.931 74.518 100.764 75.6816C99.597 76.8452 98.0138 77.4993 96.3627 77.4995H35.4825C36.0017 77.1939 36.4847 76.8223 36.9183 76.39C38.2733 75.0391 39.0349 73.2065 39.0351 71.2953V38.2969C39.0351 35.2593 41.4975 32.7969 44.5351 32.7969H97.0866Z", fill: "white", stroke: "#002A3A" }),
        React__namespace.createElement("ellipse", { cx: "1.60736", cy: "3.28154", rx: "1.60736", ry: "3.28154", transform: "matrix(-1 0 0 1 84.2051 49)", fill: "#002A3A" }),
        React__namespace.createElement("ellipse", { cx: "1.60736", cy: "3.28154", rx: "1.60736", ry: "3.28154", transform: "matrix(-1 0 0 1 60.7832 49)", fill: "#002A3A" }),
        React__namespace.createElement("path", { d: "M66.0645 60.7354C66.4177 59.5712 68.0074 57.7521 71.4518 57.7521C74.8078 57.7521 76.2209 59.7167 76.3975 60.7354", stroke: "#002A3A", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__namespace.createElement("path", { d: "M51.5826 64.7961C49.5465 62.2047 52.2613 57.9473 53.8038 55.541L53.8038 55.5411C54.5443 57.022 56.0251 59.9835 56.2101 62.5749C56.3688 64.7961 53.7098 67.5035 51.5826 64.7961Z", fill: "#00AFFF" })),
    React__namespace.createElement(Text.Text, { size: 16, strong: true }, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0448\u043B\u0438 :("),
    React__namespace.createElement(Text.Text, { className: NotFound_module.default.text }, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u0435 \u043F\u043E\u0438\u0441\u043A \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437")));

exports.NotFound = NotFound;
//# sourceMappingURL=NotFound.js.map
